import type {BackgroundLayout, BgColor} from '../../lib/lvs-foni'
import {DataTable, ParamRow} from '../ui/data-table'
import {lvsRef, round4} from '../../lib/utils'

export interface FoniParamsTableProps {
    readonly layout: BackgroundLayout
    readonly bgColor: BgColor
    readonly strike: boolean
}

/**
 * Canonical foni parameters table: outer/inner dimensions, borders,
 * corner radius, padding (0.5h), strike width (0.4h), iterations.
 * Used by FoniPage directly and by the konstruktors wizard's PreviewStep.
 */
export function FoniParamsTable({layout, bgColor, strike}: FoniParamsTableProps) {
    const margin = 0.5 * layout.maxRowHeight
    const strikeWidth = 0.4 * layout.maxRowHeight

    return (
        <DataTable>
            <DataTable.Head>
                <DataTable.HeadCell>Parametrs</DataTable.HeadCell>
                <DataTable.HeadCell>Vērtība</DataTable.HeadCell>
                <DataTable.HeadCell>Standarta atsauce</DataTable.HeadCell>
            </DataTable.Head>
            <tbody>
                <ParamRow
                    label='Ārējais W'
                    value={`${round4(layout.width)} mm`}
                    ref_='—'
                />
                <ParamRow
                    label='Ārējais H'
                    value={`${round4(layout.height)} mm`}
                    ref_='—'
                />
                <ParamRow
                    label='Diagonāle'
                    value={`${round4(layout.diagonal)} mm (${(layout.diagonal / 1000).toFixed(3)} m)`}
                    ref_='—'
                />
                <ParamRow
                    label='Kontrastapmale'
                    value={`${layout.contrastBorder} mm`}
                    ref_={lvsRef(bgColor === 'white' ? '9.15' : '9.14', 'table')}
                />
                <ParamRow
                    label='Melnā mala'
                    value={layout.blackEdge > 0 ? `${layout.blackEdge} mm` : '—'}
                    ref_={layout.blackEdge > 0 ? lvsRef('9.15', 'table') : '—'}
                />
                <ParamRow
                    label='Stūra rādiuss'
                    value={`${layout.cornerRadius} mm`}
                    ref_={lvsRef('9.16', 'table')}
                />
                <ParamRow
                    label='Iekšējais W'
                    value={`${round4(layout.innerBox.width)} mm`}
                    ref_='—'
                />
                <ParamRow
                    label='Iekšējais H'
                    value={`${round4(layout.innerBox.height)} mm`}
                    ref_='—'
                />
                <ParamRow
                    label='Atkāpe (0.5h)'
                    value={`${round4(margin)} mm`}
                    ref_={lvsRef('9.20', 'clause')}
                />
                <ParamRow
                    label='Šķērssvītra (0.4h)'
                    value={strike ? `${round4(strikeWidth)} mm` : '—'}
                    ref_={strike ? lvsRef('9.20', 'clause') : '—'}
                />
                <ParamRow
                    label='Iterāciju skaits'
                    value={`${layout.iterations}`}
                    ref_='—'
                />
            </tbody>
        </DataTable>
    )
}
